export const expectedDomainHeaders = [
  "Column Name",
  "Key",
  "Mandatory",
  "Data Type",
  "Data Format",
];

export const expectedResourceColumnHeaders = [
  ...expectedDomainHeaders,
  "Column Length",
];
